<template>
    <div class="max_main_box" :style="'background-image: url(' + activity_background + ')'">
        <headerNoticeBox></headerNoticeBox>
        <div class="line_space space10"></div>
        <div class="line_space space10"></div>
        <div class="line_space space7"></div>
        <div class="content_box">
            <div class="inner_box">
                <div class="title_line">游客预约登记</div>
                <div class="line_space space6"></div>
                <div class="input_line">
                    <div class="title">预约日期</div>
                    <div class="value">
                        <div class="date_select_line" @click="openDateSelect">
                            <div class="icon icon_calendar"></div>
                            <div class="txt">{{date_select_value}}</div>
                        </div>
                    </div>
                </div>
                <div class="line_space space2"></div>
                <div class="input_line">
                    <div class="title">预约时段</div>
                    <div class="value">
                        <div class="select_line" @click="openTimeSelect">{{activity_time_info.title}}</div>
                    </div>
                </div>
                <div class="line_space space6"></div>
                <div class="num_notice">{{activity_time_info.title}}可预约人数：<span class="color_red0">{{can_num}}</span></div>
                <div class="line_space space2"></div>
                <div class="btn_list">
                    <div class="btn_line" :class="{'disabled':can_num <= 0}" @click="goMember">去预约登记</div>
                </div>
            </div>
        </div>

        <van-popup v-model="date_select_show" position="bottom">
            <van-datetime-picker
                    show-toolbar
                    type="date"
                    v-model="date_current"
                    :min-date="date_start"
                    :max-date="date_end"
                    @confirm="confirmDateSelect"
                    @cancel="closeDateSelect"
            />
        </van-popup>

        <van-popup v-model="activity_time_show" position="bottom">
            <van-picker
                    show-toolbar
                    title="时间段选择"
                    :columns="activity_time_columns"
                    @cancel="closeTimeSelect"
                    @confirm="confirmTimeSelect"
            >
            </van-picker>
        </van-popup>

        <van-popup v-model="activity_notice_show">
            <div class="notice_box">
                <div class="close icon icon_close" @click="closeActivityNotice"></div>
                <div class="title">
                    <div class="icon"></div>
                    <div class="text">活动须知</div>
                    <div class="icon"></div>
                </div>
                <div class="content" v-html="activity_info.notice"></div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import headerNoticeBox from '../../components/headerNoticeBox'
    import mixins_reserve from '../../mixins/reserve'
    import * as api from "../../api/reserve";

    export default {
        name: "registerStart"
        ,mixins: [mixins_reserve]
        ,components: {headerNoticeBox}
        ,data: function () {
            return {
                /* 日期选择器 */
                date_select_show: false
                ,date_select_value: ''
                ,date_start: null
                ,date_end: null
                ,date_current: null

                ,activity_notice_show: false

                ,activity_info: {}
                ,activity_time_index: null
                ,activity_time_list: []
                ,activity_time_info: {}
                ,activity_time_columns: []
                ,activity_time_show: false
                ,current_num: 0     //当前已月月人数
                ,can_num: 0     //可预约人数
            }
        }
        ,created: function() {
            this.getActivityInfo();
            this.getActivityBanner0();
        }
        ,watch: {
            date_select_value: function () {
                this.getActivityOrderNum();
            }
        }
        ,methods: {
            /**
             * 初始化时间选择器
             */
            loadDateSelect: function () {
                let that = this;

                let now_obj = this.getNowObj();

                // 决定开始时间
                if(new Date(that.activity_info.begin_date) < new Date()){
                    let this_activity_finish_time = this.activity_time_list[this.activity_time_list.length - 1].finish_time.split(':');
                    if(
                        parseInt(this_activity_finish_time[0]) < now_obj.hour
                        || (parseInt(this_activity_finish_time[0]) == now_obj.hour && parseInt(this_activity_finish_time[1]) < now_obj.min)
                    ){
                        that.date_start = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
                    }else{
                        that.date_start = new Date();
                    }
                }else{
                    that.date_start = new Date(that.activity_info.begin_date);
                }

                // 决定结束时间
                if(new Date(that.activity_info.finish_date) < new Date()){
                    that.$dialog.alert({
                        message: '该活动已过期'
                    }).then(() => {
                        that.routerBack();
                    });
                }else{
                    that.date_end = new Date(that.activity_info.finish_date);
                }
                that.date_current = that.date_start > new Date() ? that.date_start : new Date();
                that.confirmDateSelect(that.date_current.getTime());
                that.getActivityOrderNum();
            }
            /**
             * 选择框 - 日期年月日
             */
            ,openDateSelect: function () {
                this.date_select_show = true;
            }
            ,closeDateSelect: function () {
                this.date_select_show = false;
            }
            ,confirmDateSelect: function (value) {
                this.date_select_value = this.dateFormat('YYYY-MM-DD', value);
                this.closeDateSelect();
                this.buildTimeSelect();
            }
            /**
             * 选择框 - 日期年月日
             */
            ,openTimeSelect: function () {
                this.activity_time_show = true;
            }
            ,closeTimeSelect: function () {
                this.activity_time_show = false;
            }
            ,buildTimeSelect: function () {
                let columns = [];
                let now = this.getNowObj();
                let default_index = null;
                for (let i in this.activity_time_list){
                    let disabled = false;
                    // 判断当天当时段是否超出列表范围内，否则不可选
                    let this_activity_finish_time = this.activity_time_list[i].finish_time.split(':');
                    if(this.date_select_value == now.year + '-' + now.month + '-' + now.day
                        && (
                            parseInt(this_activity_finish_time[0]) < now.hour
                            || (parseInt(this_activity_finish_time[0]) == now.hour && parseInt(this_activity_finish_time[1]) < now.min)
                        )
                    ) {
                        disabled = true;
                    }else{
                        // 默认选择可选的第一个
                        if(this.isEmpty(default_index)) default_index = i;
                    }
                    columns.push({text:this.activity_time_list[i].title, disabled});
                }
                this.activity_time_columns = columns;
                this.confirmTimeSelect('', default_index);
            }
            ,confirmTimeSelect: function (value, index) {
                if(this.isEmpty(index)) return false;
                this.closeTimeSelect();
                if(this.activity_time_index === index) return false;
                this.activity_time_index = index;
                this.activity_time_info = this.activity_time_list[index];
                this.getActivityOrderNum();
            }
            /**
             * 获得当前时间独享
             */
            ,getNowObj(){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                if(month < 10) month = '0' + month;
                let day = date.getDate();
                if(day < 10) day = '0' + day;
                let hour = date.getHours();
                if(hour < 10) hour = '0' + hour;
                let min = date.getMinutes();
                if(min < 10) min = '0' + min;
                let second = date.getSeconds();
                if(second < 10) second = '0' + second;
                return {year, month, day, hour, min, second}
            }
            /**
             * 展示注意事项
             */
            ,openActivityNotice: function () {
                this.activity_notice_show = true;
            }
            /**
             * 关闭注意事项
             */
            ,closeActivityNotice: function () {
                this.activity_notice_show = false;
            }
            /**
             * 获得活动信息
             */
            ,getActivityInfo: function () {
                let that = this;

                api.getActivityInfo(that.activity_id).then(function (res) {
                    that.activity_info = res.data.activity_info;
                    that.activity_time_list = res.data.activity_time_list;
                    that.buildTimeSelect();
                    that.confirmTimeSelect('', 0);
                    that.loadDateSelect();

                    if(!that.isEmpty(that.activity_info.notice)) that.openActivityNotice();
                });
            }
            /**
             * 获得当前已预约人数
             */
            ,getActivityOrderNum: function () {
                let that = this;
                if(that.isEmpty(that.date_select_value)) return false;
                if(that.isEmpty(that.activity_time_info)) return false;

                api.getActivityOrderNum(that.activity_id, that.activity_time_info.id, that.date_select_value).then(function (res) {
                    that.current_num = res.data.current_num;
                    that.can_num = that.activity_time_info.max_order_num - that.current_num;
                });
            }
            /**
             * 判断是否可以预约
             */
            ,isActivityRecord: function (callback) {
                let that = this;

                api.isDoActivityRecord(that.activity_id, that.activity_time_info.id, that.date_select_value).then(function () {
                    callback && callback();
                }).catch(function (res) {
                    that.$toast(res.msg);
                });
            }
            /**
             * 去添加成员
             */
            ,goMember: function () {
                let that = this;
                if(that.can_num <= 0) return false;

                that.isActivityRecord(function () {
                    that.$ls('activity_info', that.activity_info);
                    that.$ls('activity_time_info', that.activity_time_info);

                    that.routerToName('reserveRegisterMember', {
                        activity_id: that.activity_id
                        ,activity_time_id: that.activity_time_info.id
                        ,activity_date: that.date_select_value
                    })
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content_box{
        width: 100%;

        .inner_box{
            box-sizing: border-box;
            width: 6.4rem;
            background-color: $color_bg_green0;
            border: .02rem solid $color_bdr_green0;
            border-radius: .12rem;
            padding: .6rem;
            margin: 0 auto;

            .title_line{
                text-align: center;
                font-weight: bold;
                font-size: .48rem;
                color: $color_green0;
            }
            .input_line{
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: .66rem;

                .title{
                    width: 1.4rem;
                }
                .value{
                    width: 3.6rem;

                    .date_select_line{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box;
                        height: .62rem;
                        border-radius: .06rem;
                        border: .02rem solid $color_bdr_green0;
                        background-color: $color_bg_green1;
                        overflow: hidden;
                        color: #fff;
                        text-align: center;
                        font-size: .32rem;

                        > div{
                            height: .48rem;
                            line-height: .48rem;
                        }

                        .icon{
                            width: .3rem;
                            height: .3rem;
                            margin-right: .2rem;
                            margin-top: -.06rem;
                        }
                        .txt{

                        }
                    }

                    .select_line{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-sizing: border-box;
                        height: .62rem;
                        border-radius: .06rem;
                        border: .02rem solid $color_bdr_green0;
                        background-color: $color_bg_green1;
                        overflow: hidden;
                        color: #fff;
                        text-align: center;
                        font-size: .32rem;
                    }
                }
            }
            .num_notice{
                font-size: .28rem;
                color: $color_grey0;
                text-align: right;
            }

            .btn_list{

                .btn_line{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: .88rem;
                    line-height: .88rem;
                    border-radius: .88rem;
                    background-color: $color_bg_green1;
                    margin: 0 auto;
                    color: #fff;
                    text-align: center;
                    font-size: .38rem;
                    box-shadow: $box_shadow;

                    &.disabled{
                        color: $color_grey0;
                        background-color: $color_bg_grey0;
                    }
                }
            }
        }
    }
    .notice_box{
        position: relative;
        width: 6.8rem;

        .close{
            position: absolute;
            right: .2rem;
            top: .2rem;
            z-index: $z_index_2;
            width: .6rem;
            height: .6rem;
        }
        .title{
            position: sticky;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            padding: .2rem .3rem;
            font-size: .48rem;
            font-weight: bold;
            text-align: center;

            .text{
                margin: 0 .2rem;
            }
            .icon{
                width: .2rem;
                height: .2rem;
                background-color: $color_bg_green1;
            }
        }
        .content{
            max-height: 7.5rem;
            padding: .3rem;
            font-size: .32rem;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>